var map = {
	"./source/404/module/page-not-found.module": [
		"./src/app/source/404/module/page-not-found.module.ts",
		"source-404-module-page-not-found-module"
	],
	"./source/Inventory/count/module/inventory-count.module": [
		"./src/app/source/Inventory/count/module/inventory-count.module.ts",
		"source-Inventory-count-module-inventory-count-module"
	],
	"./source/Inventory/mass/module/mass-inventory.module": [
		"./src/app/source/Inventory/mass/module/mass-inventory.module.ts",
		"source-Inventory-mass-module-mass-inventory-module"
	],
	"./source/Inventory/receive/module/receive-inventory.module": [
		"./src/app/source/Inventory/receive/module/receive-inventory.module.ts",
		"source-Inventory-receive-module-receive-inventory-module"
	],
	"./source/Inventory/return/module/return-inventory.module": [
		"./src/app/source/Inventory/return/module/return-inventory.module.ts",
		"source-Inventory-return-module-return-inventory-module"
	],
	"./source/add-items/module/add-items.module": [
		"./src/app/source/add-items/module/add-items.module.ts",
		"common",
		"source-add-items-module-add-items-module"
	],
	"./source/approval/module/devices.module": [
		"./src/app/source/approval/module/devices.module.ts",
		"source-approval-module-devices-module"
	],
	"./source/apps-activation/module/apps-activation.module": [
		"./src/app/source/apps-activation/module/apps-activation.module.ts",
		"default~source-apps-activation-module-apps-activation-module~source-stores-add-store_module-add-stor~4d91b396",
		"common",
		"source-apps-activation-module-apps-activation-module"
	],
	"./source/apps/module/apps.module": [
		"./src/app/source/apps/module/apps.module.ts",
		"source-apps-module-apps-module"
	],
	"./source/attendanceReport/module/attendance-report.module": [
		"./src/app/source/attendanceReport/module/attendance-report.module.ts",
		"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52",
		"common",
		"source-attendanceReport-module-attendance-report-module"
	],
	"./source/business_type/module/business-type.module": [
		"./src/app/source/business_type/module/business-type.module.ts",
		"source-business_type-module-business-type-module"
	],
	"./source/categories/module/categories.module": [
		"./src/app/source/categories/module/categories.module.ts",
		"source-categories-module-categories-module"
	],
	"./source/closeday/module/close-day.module": [
		"./src/app/source/closeday/module/close-day.module.ts",
		"common",
		"source-closeday-module-close-day-module"
	],
	"./source/customers/module/customers.module": [
		"./src/app/source/customers/module/customers.module.ts",
		"common",
		"source-customers-module-customers-module"
	],
	"./source/daycloseprint/day-close-print/day-close-print.module": [
		"./src/app/source/daycloseprint/day-close-print/day-close-print.module.ts",
		"source-daycloseprint-day-close-print-day-close-print-module"
	],
	"./source/denied/module/denied.module": [
		"./src/app/source/denied/module/denied.module.ts",
		"source-denied-module-denied-module"
	],
	"./source/denomination/module/denomination.module": [
		"./src/app/source/denomination/module/denomination.module.ts",
		"default~source-denomination-module-denomination-module~source-import_customers-module-import-custome~4a899029",
		"common",
		"source-denomination-module-denomination-module"
	],
	"./source/departments/module/departments.module": [
		"./src/app/source/departments/module/departments.module.ts",
		"source-departments-module-departments-module"
	],
	"./source/dining/dining-section/module/dining.module": [
		"./src/app/source/dining/dining-section/module/dining.module.ts",
		"source-dining-dining-section-module-dining-module"
	],
	"./source/dining/kitchen/module/kitchen.module": [
		"./src/app/source/dining/kitchen/module/kitchen.module.ts",
		"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52",
		"common",
		"source-dining-kitchen-module-kitchen-module"
	],
	"./source/dining/serving/module/serving.module": [
		"./src/app/source/dining/serving/module/serving.module.ts",
		"source-dining-serving-module-serving-module"
	],
	"./source/dining/settings/apps_settings/module/setting.module": [
		"./src/app/source/dining/settings/apps_settings/module/setting.module.ts",
		"source-dining-settings-apps_settings-module-setting-module"
	],
	"./source/dining/settings/dispatch_screen/module/dispatch.module": [
		"./src/app/source/dining/settings/dispatch_screen/module/dispatch.module.ts",
		"source-dining-settings-dispatch_screen-module-dispatch-module"
	],
	"./source/dining/table/module/table.module": [
		"./src/app/source/dining/table/module/table.module.ts",
		"source-dining-table-module-table-module"
	],
	"./source/dining/token/module/token.module": [
		"./src/app/source/dining/token/module/token.module.ts",
		"source-dining-token-module-token-module"
	],
	"./source/drivers/module/drivers.module": [
		"./src/app/source/drivers/module/drivers.module.ts",
		"source-drivers-module-drivers-module"
	],
	"./source/edit-email/module/edit-email.module": [
		"./src/app/source/edit-email/module/edit-email.module.ts",
		"common",
		"source-edit-email-module-edit-email-module"
	],
	"./source/edit-items/module/edit-item.module": [
		"./src/app/source/edit-items/module/edit-item.module.ts",
		"common",
		"source-edit-items-module-edit-item-module"
	],
	"./source/email/module/email.module": [
		"./src/app/source/email/module/email.module.ts",
		"common",
		"source-email-module-email-module"
	],
	"./source/employee_activity/module/employee-activity.module": [
		"./src/app/source/employee_activity/module/employee-activity.module.ts",
		"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52",
		"common",
		"source-employee_activity-module-employee-activity-module"
	],
	"./source/general_settings/module/general-settings.module": [
		"./src/app/source/general_settings/module/general-settings.module.ts",
		"common",
		"source-general_settings-module-general-settings-module"
	],
	"./source/home/module/home.module": [
		"./src/app/source/home/module/home.module.ts",
		"source-home-module-home-module"
	],
	"./source/import_customers/module/import-customers.module": [
		"./src/app/source/import_customers/module/import-customers.module.ts",
		"default~source-denomination-module-denomination-module~source-import_customers-module-import-custome~4a899029",
		"common",
		"source-import_customers-module-import-customers-module"
	],
	"./source/import_items/module/import-items.module": [
		"./src/app/source/import_items/module/import-items.module.ts",
		"default~source-denomination-module-denomination-module~source-import_customers-module-import-custome~4a899029",
		"common",
		"source-import_items-module-import-items-module"
	],
	"./source/import_vendors/module/import-vendors.module": [
		"./src/app/source/import_vendors/module/import-vendors.module.ts",
		"default~source-denomination-module-denomination-module~source-import_customers-module-import-custome~4a899029",
		"common",
		"source-import_vendors-module-import-vendors-module"
	],
	"./source/inventory_snapshot/module/inventory-snapshot.module": [
		"./src/app/source/inventory_snapshot/module/inventory-snapshot.module.ts",
		"source-inventory_snapshot-module-inventory-snapshot-module"
	],
	"./source/invoice_credit/module/invoice-credit.module": [
		"./src/app/source/invoice_credit/module/invoice-credit.module.ts",
		"source-invoice_credit-module-invoice-credit-module"
	],
	"./source/invoice_refund/module/invoice-refund.module": [
		"./src/app/source/invoice_refund/module/invoice-refund.module.ts",
		"source-invoice_refund-module-invoice-refund-module"
	],
	"./source/item_refund/module/item-refund.module": [
		"./src/app/source/item_refund/module/item-refund.module.ts",
		"source-item_refund-module-item-refund-module"
	],
	"./source/item_sales/module/item-sales.module": [
		"./src/app/source/item_sales/module/item-sales.module.ts",
		"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52",
		"common",
		"source-item_sales-module-item-sales-module"
	],
	"./source/items/fodi-eat-info/module/fodi-eat-info.module": [
		"./src/app/source/items/fodi-eat-info/module/fodi-eat-info.module.ts",
		"source-items-fodi-eat-info-module-fodi-eat-info-module"
	],
	"./source/items/module/items.module": [
		"./src/app/source/items/module/items.module.ts",
		"common",
		"source-items-module-items-module"
	],
	"./source/loyality/module/loyality-program.module": [
		"./src/app/source/loyality/module/loyality-program.module.ts",
		"source-loyality-module-loyality-program-module"
	],
	"./source/modifiers/modifiers-group-module/modifiers-group.module": [
		"./src/app/source/modifiers/modifiers-group-module/modifiers-group.module.ts",
		"default~source-modifiers-modifiers-group-module-modifiers-group-module~source-modifiers-modifiers_mo~4fd2ab00",
		"common",
		"source-modifiers-modifiers-group-module-modifiers-group-module"
	],
	"./source/modifiers/modifiers_module/modifiers.module": [
		"./src/app/source/modifiers/modifiers_module/modifiers.module.ts",
		"default~source-modifiers-modifiers-group-module-modifiers-group-module~source-modifiers-modifiers_mo~4fd2ab00",
		"common",
		"source-modifiers-modifiers_module-modifiers-module"
	],
	"./source/orders-list/module/orders-list.module": [
		"./src/app/source/orders-list/module/orders-list.module.ts",
		"common",
		"source-orders-list-module-orders-list-module"
	],
	"./source/payment/module/payment.module": [
		"./src/app/source/payment/module/payment.module.ts",
		"default~source-denomination-module-denomination-module~source-import_customers-module-import-custome~4a899029",
		"common",
		"source-payment-module-payment-module"
	],
	"./source/permissions/module/permission.module": [
		"./src/app/source/permissions/module/permission.module.ts",
		"source-permissions-module-permission-module"
	],
	"./source/print-invoice/module/print-invoice.module": [
		"./src/app/source/print-invoice/module/print-invoice.module.ts",
		"common",
		"source-print-invoice-module-print-invoice-module"
	],
	"./source/print-report/module/print-report.module": [
		"./src/app/source/print-report/module/print-report.module.ts",
		"common",
		"source-print-report-module-print-report-module"
	],
	"./source/printer/printer-config/printer-config.module": [
		"./src/app/source/printer/printer-config/printer-config.module.ts",
		"default~source-printer-printer-config-printer-config-module~source-printer-printer-group_module-prin~88a6af20",
		"common",
		"source-printer-printer-config-printer-config-module"
	],
	"./source/printer/printer-group_module/printer-group.module": [
		"./src/app/source/printer/printer-group_module/printer-group.module.ts",
		"default~source-printer-printer-config-printer-config-module~source-printer-printer-group_module-prin~88a6af20",
		"common",
		"source-printer-printer-group_module-printer-group-module"
	],
	"./source/printer/printer_module/printers.module": [
		"./src/app/source/printer/printer_module/printers.module.ts",
		"default~source-printer-printer-config-printer-config-module~source-printer-printer-group_module-prin~88a6af20",
		"common",
		"source-printer-printer_module-printers-module"
	],
	"./source/promotions/module/promotions.module": [
		"./src/app/source/promotions/module/promotions.module.ts",
		"source-promotions-module-promotions-module"
	],
	"./source/reason/module/reason.module": [
		"./src/app/source/reason/module/reason.module.ts",
		"source-reason-module-reason-module"
	],
	"./source/roles/module/roles.module": [
		"./src/app/source/roles/module/roles.module.ts",
		"source-roles-module-roles-module"
	],
	"./source/sale_summary/module/sale-summary.module": [
		"./src/app/source/sale_summary/module/sale-summary.module.ts",
		"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52",
		"common",
		"source-sale_summary-module-sale-summary-module"
	],
	"./source/sell/module/sell.module": [
		"./src/app/source/sell/module/sell.module.ts",
		"default~source-denomination-module-denomination-module~source-import_customers-module-import-custome~4a899029",
		"common",
		"source-sell-module-sell-module"
	],
	"./source/store_summary/module/store-summary.module": [
		"./src/app/source/store_summary/module/store-summary.module.ts",
		"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52",
		"common",
		"source-store_summary-module-store-summary-module"
	],
	"./source/stores/add-store_module/add-store.module": [
		"./src/app/source/stores/add-store_module/add-store.module.ts",
		"default~source-apps-activation-module-apps-activation-module~source-stores-add-store_module-add-stor~4d91b396",
		"default~source-stores-add-store_module-add-store-module~source-stores-stores_module-stores-module",
		"common",
		"source-stores-add-store_module-add-store-module"
	],
	"./source/stores/stores_module/stores.module": [
		"./src/app/source/stores/stores_module/stores.module.ts",
		"default~source-stores-add-store_module-add-store-module~source-stores-stores_module-stores-module",
		"common",
		"source-stores-stores_module-stores-module"
	],
	"./source/switch_store/module/switch_store.module": [
		"./src/app/source/switch_store/module/switch_store.module.ts",
		"source-switch_store-module-switch_store-module"
	],
	"./source/tax/module/tax.module": [
		"./src/app/source/tax/module/tax.module.ts",
		"source-tax-module-tax-module"
	],
	"./source/theme/module/theme.module": [
		"./src/app/source/theme/module/theme.module.ts",
		"source-theme-module-theme-module"
	],
	"./source/timeclock/module/time-clock.module": [
		"./src/app/source/timeclock/module/time-clock.module.ts",
		"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52",
		"common",
		"source-timeclock-module-time-clock-module"
	],
	"./source/transactions-report/module/transactions-report.module": [
		"./src/app/source/transactions-report/module/transactions-report.module.ts",
		"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52",
		"common",
		"source-transactions-report-module-transactions-report-module"
	],
	"./source/uom/module/uom.module": [
		"./src/app/source/uom/module/uom.module.ts",
		"source-uom-module-uom-module"
	],
	"./source/user/profile_module/profile.module": [
		"./src/app/source/user/profile_module/profile.module.ts",
		"common",
		"source-user-profile_module-profile-module"
	],
	"./source/user/users_module/users.module": [
		"./src/app/source/user/users_module/users.module.ts",
		"common",
		"source-user-users_module-users-module"
	],
	"./source/vandors/module/vandors.module": [
		"./src/app/source/vandors/module/vandors.module.ts",
		"source-vandors-module-vandors-module"
	],
	"./source/variants/variant-group_module/variant-group.module": [
		"./src/app/source/variants/variant-group_module/variant-group.module.ts",
		"common",
		"source-variants-variant-group_module-variant-group-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;